import { useState } from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useNavigate } from "react-router-dom";
import { createNewCognitoUser, confirmCode } from "../offchain-logic/services";
import { getRegistrationErrorMessage, messages } from "../common/messages";
import InsertCodeDialog from "./component/InsertCodeDialog";
import CentralizedDialog from './component/CentralizedDialog';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const COLOR = "#20679F"

function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright '}
            &copy; {' '}
            <Link color="inherit" href="#">
                MAMADOC
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

export default function Enroll(props: any) {

    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [ragioneSociale, setRagioneSociale] = useState<string>("");
    const [indirizzo, setIndirizzo] = useState<string>("");
    const [civico, setCivico] = useState<string>("");
    const [cap, setCap] = useState<string>("");
    const [comune, setComune] = useState<string>("");
    const [provincia, setProvincia] = useState<string>("");
    const [pIva, setPIva] = useState<string>("");
    const [codFiscale, setCodFiscale] = useState<string>("");
    const [phone, setPhone] = useState<string>("");
    const [pec, setPEC] = useState<string>("");
    const [code, setCode] = useState<string>("");
    const [errorMessage, setErrorMessage] = useState<string | undefined>();
    const [openDialog, setOpenDialog] = useState(false);
    const [isOpenCentrlizedDialog, setIsOpenCentrlizedDialog] = useState(false);
    const MY_COLOR = 'blue'; // Definisci la tua costante
    
    // Funzione per aprire/chiudere
    const handleClose = () => setOpenDialog(false);

    const handleConfirmCentrlizedDialog = () => {
        console.log("Codice confermato:", code);
        // Chiamata all'API di conferma Cognito qui
        setIsOpenCentrlizedDialog(false);
        navigate("/login");
    };

        // Funzione da eseguire quando il codice viene confermato
    const handleConfirm = (code: string) => {
        console.log("Codice inserito:", code);
        // Qui chiami l'API di conferma Cognito (ConfirmSignUpCommand)
    
            confirmCode({
                'ConfirmationCode': code,
                'Username': email,
            }, (err, res) => {
                setOpenDialog(false);
                if(err !== null){
                    console.error(err);
                    if(err.code === "InvalidParameterException"){
                        setErrorMessage("Verifica la correttezza dei valori dei campi inseriti e riprova.");
                    } else {
                        setErrorMessage("Si è verificato un problema, riprova più tardi.");
                    }
                    return;
                }

                setIsOpenCentrlizedDialog(true);

                /*
                let payload = {
                    "email": email
                };
                
                insertUserAWS(payload, (err, res) => {
                    console.log("insertAWS res: " + res + " -- err: " + err);
                    if(err !== null || res === null){
                        props.handleOpenToast("Si è verificato un problema, riprova più tardi.", 'error');
                        return;
                    }
                    handleClose(); // Chiudi il dialogo dopo l'azione
                    navigate("/login");
                });

                */
            });
    };

    const navigate = useNavigate();

    const handleSubmitRegister = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (email === "" || password === "") {
            console.error("Email e password sono campi obbligatori");
            props.handleOpenToast(messages.auth.requiredCredentials, 'error');
            return;
        }
        const requiredFields = [
            { value: ragioneSociale, label: 'Ragione Sociale' },
            { value: indirizzo, label: 'Indirizzo' },
            { value: civico, label: 'Civico' },
            { value: cap, label: 'CAP' },
            { value: comune, label: 'Comune' },
            { value: provincia, label: 'Provincia' },
            { value: pIva, label: 'Partita IVA' },
            { value: codFiscale, label: 'Codice Fiscale' },
            { value: phone, label: 'Telefono' },
            { value: pec, label: 'PEC' },
        ];
        const missingFields = requiredFields
            .filter(field => !field.value.trim())
            .map(field => field.label);
        if (missingFields.length > 0) {
            props.handleOpenToast(`Compila il campo obbligatorio: ${missingFields.join(', ')}`, 'error');
            return;
        }

        if (!/^\d{5}$/.test(cap.trim()) || !/^[A-Za-z]{2}$/.test(provincia.trim())) {
            props.handleOpenToast('Inserisci un CAP di 5 cifre e una provincia di 2 lettere.', 'error');
            return;
        }

        const phoneRegex = /(\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9})/;
        const pwdRegex = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/;
        if(!pwdRegex.test(password)) {
            props.handleOpenToast(messages.registration.invalidPassword);
            return;
        }
        if(!phoneRegex.test(phone)) {
            props.handleOpenToast(messages.registration.invalidPhone);
            return;
        }

        createNewCognitoUser(email, password, ragioneSociale, pIva, codFiscale, phone, pec, {
            indirizzo: indirizzo.trim(),
            civico: civico.trim(),
            cap: cap.trim(),
            comune: comune.trim(),
            provincia: provincia.trim().toUpperCase(),
            paese: 'IT'
        }, (err, res) => {
            if(err !== null){
                props.handleOpenToast(getRegistrationErrorMessage(err), 'error');
                console.error(err);
                return;
            }
            console.log("res: " + res);
            if(res !== null){
                if(!res.UserConfirmed){

                    setOpenDialog(true);

                } else {
                    //getAuthResult(res);
                    const responseData = res.data;
                    console.log(responseData);
                    alert(responseData.message)
                    navigate("/login");
                }
            }
        });
    }

    return (<>
        <Grid
            container
            component="main"
            sx={{
                minHeight: '100vh',
                height: 'auto',
                overflowY: 'auto',
                overflowX: 'hidden',
            }}
        >
            <CssBaseline />
            <Grid item xs={12} sm={9} md={7} component={Paper} elevation={6} square>
                <Box
                    sx={{
                        my: 8,
                        mx: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Typography component="h1" variant="h3" fontWeight="bold" color={COLOR}>
                        Registrati
                    </Typography>
                    <Box component="form" noValidate onSubmit={handleSubmitRegister} sx={{ mt: 3 }}>

                        <fieldset 
                            style={{ 
                                border: `1px solid ${COLOR}`, 
                                padding: '10px 20px', 
                                margin: '20px 0', 
                                borderRadius: '4px' 
                            }}
                        >
                            <legend style={{ 
                                color: COLOR, 
                                fontWeight: 'bold', 
                                padding: '0 10px',
                                fontSize: '1.2em'
                            }}>
                                Credenziali Account
                            </legend>

                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="Indirizzo Email"
                                name="email"
                                autoComplete="email"
                                onChange={e => { setEmail(e.target.value) }}
                            />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                onChange={e => { setPassword(e.target.value) }}
                            />
                        </fieldset>


                        <fieldset 
                            style={{ 
                                border: `1px solid ${COLOR}`, 
                                padding: '10px 20px', 
                                margin: '20px 0', 
                                borderRadius: '4px' 
                            }}
                        >
                            <legend style={{ 
                                color: COLOR, 
                                fontWeight: 'bold', 
                                padding: '0 10px',
                                fontSize: '1.2em'
                            }}>
                                Info Account
                            </legend>

                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="ragioneSociale"
                                label="Ragione Sociale"
                                name="ragioneSociale"
                                onChange={e => setRagioneSociale(e.target.value)}
                                value={ragioneSociale}
                            />

                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <TextField margin="normal" required fullWidth id="indirizzo" label="Indirizzo" value={indirizzo} onChange={e => setIndirizzo(e.target.value)} />
                                <TextField margin="normal" required sx={{ width: '35%' }} id="civico" label="Civico" value={civico} onChange={e => setCivico(e.target.value)} />
                            </Box>
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <TextField margin="normal" required sx={{ width: '25%' }} id="cap" label="CAP" inputProps={{ maxLength: 5, inputMode: 'numeric' }} value={cap} onChange={e => setCap(e.target.value.replace(/\D/g, '').slice(0, 5))} />
                                <TextField margin="normal" required fullWidth id="comune" label="Comune" value={comune} onChange={e => setComune(e.target.value)} />
                                <TextField margin="normal" required sx={{ width: '25%' }} id="provincia" label="Provincia" inputProps={{ maxLength: 2 }} value={provincia} onChange={e => setProvincia(e.target.value.replace(/[^a-z]/gi, '').slice(0, 2).toUpperCase())} />
                            </Box>

                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="pIva"
                                label="Partita Iva"
                                name="pIva"
                                onChange={e => setPIva(e.target.value)}
                                value={pIva}
                            />

                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="codFiscale"
                                label="Codice Fiscale"
                                name="codFiscale"
                                onChange={e => setCodFiscale(e.target.value)}
                                value={codFiscale}
                            />

                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                type='tel'
                                id="phone"
                                label="Numero di Telefono"
                                name="phone"
                                onChange={e => setPhone(e.target.value)}
                                value={phone}
                            />

                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="pec"
                                label="PEC"
                                name="pec"
                                onChange={e => setPEC(e.target.value)}
                                value={pec}
                            />
                        </fieldset>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} mt={3}>
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{ borderRadius: '50px', mt: 2, mb: 2, backgroundColor: COLOR }}
                            >
                                CONFERMA
                            </Button>
                        </Box>
                        <Copyright sx={{ mt: 5 }} />
                    </Box>
                </Box>
            </Grid>
            <Grid
                item
                xs={false}
                sm={3}
                md={5}
                sx={{
                    backgroundColor: COLOR,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ height: '100%' }}
                >
                    <Grid item sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                        <Typography variant="h3" align="center" color={'white'} fontWeight="bold" mb={3} >
                            Bentornato!
                        </Typography>
                        <Typography variant="body1" color={'white'} align="center"
                            sx={{ width: '60%', margin: '0 auto' }}>
                            Se possiedi già un account, accedi
                        </Typography>
                        <Button
                            type="submit"
                            variant="contained"
                            sx={{
                                borderRadius: '50px',
                                mt: 3,
                                mb: 2,
                                backgroundColor: 'transparent',
                                border: '2px solid #FFFFFF',
                                width: '15em',
                                color: '#FFFFFF',
                            }}
                            onClick={() => navigate("/login")}
                        >
                            <Typography variant="h6" align="center">
                                ACCEDI
                            </Typography>

                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>

        <InsertCodeDialog
            open={openDialog}
            handleClose={handleClose}
            handleConfirmCode={handleConfirm}
            COLOR={MY_COLOR}
        />

        <CentralizedDialog
            open={isOpenCentrlizedDialog}
            onClose={handleConfirmCentrlizedDialog}
            title="Verifica il tuo Account"
            maxWidth="xs"
            icon={<CheckCircleOutlineIcon />}
            iconColor="#2e7d32"
            children={"La registrazione è andata a buon fine. Puoi procedere con la prima login."} 
            primaryAction={{
                label: "OK",
                onClick: handleConfirmCentrlizedDialog
            }}
        />

    </>);
}